<template>
  <div v-if="device && groups">
    <div class="groups groups__device-detail">
      <div class="groups__device">
        {{ $filters.firstUpper($t("zarizeni")) }}

        <div class="groups__device__icon mb-3">
          <div class="atom-icon mr-0">
            <img alt="" src="@/assets/icons/devices/ico-zarizeni-cerna.svg" />
          </div>
        </div>

        <h6 class="mb-3">
          {{ device.custDeviceName }}
        </h6>

        <div v-if="device.lastMessageIn" class="groups__message-wrapper">
          <div class="atom-icon mb-2 mr-0">
            <img alt="" src="@/assets/icons/actions/ico-zprava-green.svg" />
          </div>
          <div class="groups__message text-left">
            <div class="font-weight-light">
              {{ $filters.firstUpper($t("posledniZprava")) }}
            </div>
            <div
              v-if="lastMessageIn && lastMessageIn.message"
              class="link-gray"
              @click="$emit('showMessage', lastMessageIn)"
            >
              <span>{{ $filters.strLimit(lastMessageIn.message.EUI, 11) }}</span>
            </div>
            <div v-if="device.lastMessageIn" class="font-weight-light">
              {{ $filters.firstUpper($t("pred")) }}
              {{ $filters.beforeTime(device.lastMessageIn, "short") }}
            </div>
          </div>
        </div>
      </div>

      <div class="groups__data-flow-wrapper">
        <div
          v-show="showOtherDataFlows && otherDataFlowList.length"
          :style="{ height: wrapperLineHeight }"
          class="groups__data-flow-wrapper__custom-before"
        />

        <div v-show="firstDataFlow">
          <div class="groups__data-flow-tf-connection__custom-before" />
          <div class="groups__data-flow-tf-connection-2__custom-before" />
        </div>

        <div class="mb-3">
          {{ $filters.firstUpper($t("datovyTok")) }}
        </div>

        <DataFlow
          v-if="firstDataFlow"
          :key="`dataFlowDiv${firstDataFlow.deviceGroupId}`"
          :data-flow="firstDataFlow"
          :device-group-endpoint-list="findGroupEndpoints"
          class="groups__data-flow-box__first mb-5"
          @change="$emit('editDevice')"
        />

        <div v-else class="groups__data-flow-box">
          <div class="groups__box_header d-flex align-items-center justify-content-between">
            <h6 class="mb-0 font-weight-normal" v-text="$t('NO_DATA_FLOW_ASSIGNED')" />
            <a v-text="$t('ASSIGN')" @click.stop="$emit('editDevice')" />
          </div>
          <div class="groups__box_body" v-text="$t('NO_DATA_FLOW_ASSIGNED_INFO_TEXT')" />
        </div>

        <div v-if="otherDataFlowList.length" class="mb-5" @click="showOtherDataFlows = !showOtherDataFlows">
          <span class="link">
            {{ $filters.firstUpper($t("dalsiDatoveToky")) }}
            ({{ otherDataFlowList.length }})
          </span>
          <img
            :style="{
              transform: showOtherDataFlows ? 'rotate(180deg)' : 'none'
            }"
            alt=""
            src="@/assets/icons/arrows/arr-orange-down.svg"
            width="14"
          />
        </div>

        <DataFlow
          v-for="dataFlow of shownOtherDataFlowList"
          :key="`dataFlowDiv${dataFlow.deviceGroupId}`"
          :data-flow="dataFlow"
          class="mb-5"
          @change="$emit('editDevice')"
        />
      </div>
    </div>
  </div>
</template>

<script>
import DataFlow from "@/components/devices/partials/DataFlow.vue"

export default {
  name: "DataFlowOverview",
  components: {
    DataFlow
  },
  props: {
    device: {
      type: Object,
      required: true
    },
    deviceType: {
      type: String, // 'lora' | 'mqtt'
      required: true
    },
    groups: {
      type: Array,
      required: true
    },
    groupsEndpoints: {
      type: Array,
      required: true
    },
    lastMessageIn: {
      // tohle podle mě není potřeba
      type: Object,
      required: true
    }
  },
  emits: ["editDevice"],
  data: () => ({
    kebabOpened: false,
    modalsOpened: [],
    showOtherDataFlows: false,
    transformation: {},
    transformEditError: "",
    wrapperLineHeight: 0
  }),
  computed: {
    firstDataFlow() {
      return this.groups[0] || null
    },
    findGroupEndpoints() {
      return this.groupsEndpoints.find((g) => g.group.deviceGroupId === this.firstDataFlow.deviceGroupId)?.endpoints
    },
    otherDataFlowList() {
      return this.groups.slice(1)
    },
    shownOtherDataFlowList() {
      return this.showOtherDataFlows ? this.otherDataFlowList : []
    }
    // transformationHeader() {
    //   return this.transformation.transformationId ? this.transformation.label : this.$t("zadnaVstupniTransformace");
    // }
  },
  watch: {
    shownOtherDataFlowList: {
      handler(dfList) {
        if (dfList.length) {
          // nejdřív se musí komponenty vyrenderovat, ani nextTick nestačil, tak dávám timeout
          setTimeout(this.calculateWrapperBeforeHeight, 500)
        }
      },
      immediate: false
    }
  },
  methods: {
    calculateWrapperBeforeHeight() {
      const wrapperHeight = document.querySelector(".groups__data-flow-wrapper")?.offsetHeight
      const lastDataFlowHeight = document.querySelector(
        ".groups__data-flow-wrapper .groups__data-flow-box:last-of-type"
      )?.offsetHeight
      const lastDataFlowHeaderHeight = document.querySelector(
        ".groups__data-flow-wrapper .groups__data-flow-box:last-of-type > .groups__box_header"
      )?.offsetHeight

      if (!wrapperHeight || !lastDataFlowHeight || !lastDataFlowHeaderHeight) {
        return
      }

      this.wrapperLineHeight = `${wrapperHeight - lastDataFlowHeight - lastDataFlowHeaderHeight}px`
    },
    closeBox(box) {
      this.modalsOpened = this.modalsOpened.filter((m) => m !== box)
    },
    openBox(box) {
      this.modalsOpened = this.modalsOpened.concat(box)
    }
  }
}
</script>
